var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSearchLocalTravelPlanDesktop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icSearchLocalTravelPlanDesktop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.29942348,13.445627 C7.43403984,15.5756156 10.858608,15.6733774 13.1112516,13.6686327 L18.0422262,18.5998314 C18.169332,18.726458 18.5470909,18.9075575 18.9578352,18.5998314 C19.3685794,18.2921053 19.0844572,17.7228071 18.9578352,17.5956967 L14.0268671,12.6645078 C15.4998602,10.687334 15.4136223,7.25203701 13.1910336,5.24623652 C10.9684448,3.24043602 7.37339684,3.24043602 5.22313471,5.47456044 C3.07287258,7.70868486 3.10679486,11.2530698 5.29942348,13.445627 Z M11.1281179,5.06454865 C12.8901237,5.7944137 14.0389835,7.51385534 14.0389835,9.42109727 C14.0389835,11.3283392 12.8901237,13.0477808 11.1281179,13.7776459 C9.36611205,14.5075109 7.33795888,14.1040642 5.98938697,12.7554331 C5.10147127,11.8730398 4.60217774,10.6729203 4.60217774,9.42109601 C4.60217774,8.16927167 5.10147574,6.96915316 5.98939305,6.08676144 C7.33795888,4.73813032 9.36611205,4.3346836 11.1281179,5.06454865 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Travel",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Travel_PopularDestinations",
    transform: "translate(-1141.000000, -196.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-69",
    transform: "translate(1122.000000, 188.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "musica-searcher"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/FilterOption",
    transform: "translate(11.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/light-grey",
    transform: "translate(15.882676, 16.009374) rotate(-32.000000) translate(-15.882676, -16.009374) translate(4.882676, 5.009374)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icSearchLocalTravelPlanDesktop",
    fill: "#535353",
    fillRule: "nonzero",
    transform: "translate(11.402169, 11.269273) scale(-1, 1) rotate(56.000000) translate(-11.402169, -11.269273) ",
    xlinkHref: "#path-1"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchLocalTravelPlanDesktop);
export default __webpack_public_path__ + "static/media/icSearchLocalTravelPlanDesktop.55bf7069e3a6d3dd61a701cc817a3469.svg";
export { ForwardRef as ReactComponent };